import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

export default function PolicyPage() {
    const { key } = useParams();
    const [policy, setPolicy] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        setPolicy(null); setError(false);
        api.get(`/policies/${key}`).then(({ data }) => setPolicy(data.policy)).catch(() => setError(true));
    }, [key]);

    if (error) return <div className="py-28 text-center font-serif text-2xl">Content not available.</div>;

    return (
        <div className="mx-auto max-w-3xl px-5 py-14">
            {policy ? (
                <>
                    <h1 className="font-serif text-4xl md:text-5xl tracking-tight mb-8">{policy.title}</h1>
                    <div className="whitespace-pre-line text-muted-foreground leading-relaxed">{policy.content}</div>
                </>
            ) : (
                <div className="space-y-4"><div className="skeleton h-10 w-1/2" /><div className="skeleton h-40 w-full" /></div>
            )}
        </div>
    );
}
